import { ChevronRightIcon, Icon, Pane, PaneProps } from "evergreen-ui";
import { useState } from "react";
import { useGFTheme } from "../../lib/themes";

import styles from "./AccordioItem.module.css";
import classNames from "classnames";

interface AccordionItemProps extends PaneProps {
  title: string;
  defaultOpen?: boolean;
}
export const AccordionItem = ({
  title,
  defaultOpen,
  children,
  ...props
}: AccordionItemProps) => {
  const { colors } = useGFTheme();
  const [open, setOpen] = useState<boolean | null>(null);
  const calcOpen = open === null ? !!defaultOpen : open;
  return (
    <Pane {...props}>
      <Pane
        is="button"
        display="flex"
        width="100%"
        border="0"
        backgroundColor="transparent"
        textAlign="left"
        alignItems="center"
        cursor="pointer"
        gap="1rem"
        onClick={() => setOpen(!calcOpen)}
      >
        <Pane
          is="h2"
          fontFamily="work-sans"
          color={colors.greenDark}
          className={styles.h2}
          fontSize="1.2rem"
          flex={1}
          fontWeight={400}
        >
          {title}
        </Pane>
        <Icon
          icon={ChevronRightIcon}
          strokeWidth="2px"
          color={colors.greenDark}
          className={classNames(styles.titleChevron, {
            [styles.open]: calcOpen,
          })}
          size={36}
        />
      </Pane>
      <Pane className={classNames(styles.content, { [styles.open]: calcOpen })}>
        {children}
      </Pane>
    </Pane>
  );
};
